import { put, takeLatest, call } from "redux-saga/effects";
import { getRelatorioConsumo } from "../../crud/financeiro.crud";

export const actionTypes = {
    FetchConsumption: "[FetchConsumption] Action",
    LoadConsumption: "[LoadConsumption] Action",
};

const initialState = {
    agentMessageLimitReached: false,
    loading: false,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FetchConsumption:
            return { ...state, loading: true };
        case actionTypes.LoadConsumption:
            return { ...state, ...action.payload, loading: false };
        default:
            return state;
    }
};

export const consumptionActions = {
    fetchConsumption: () => ({ type: actionTypes.FetchConsumption }),
    loadConsumption: (payload) => ({ type: actionTypes.LoadConsumption, payload }),
};

function* fetchConsumptionSaga() {
    try {
        const { data } = yield call(getRelatorioConsumo);
        const msgs = data?.agentes?.mensagens;
        const agentMessageLimitReached = Boolean(msgs && msgs.max !== -1 && (msgs.max === 0 || msgs.max == null || msgs.count >= msgs.max));
        yield put(consumptionActions.loadConsumption({ agentMessageLimitReached }));
    } catch {
        yield put(consumptionActions.loadConsumption({ agentMessageLimitReached: false }));
    }
}

export function* saga() {
    yield takeLatest(actionTypes.FetchConsumption, fetchConsumptionSaga);
}
